import $ from "jquery";
import "slick-carousel";

$(".resources-list-featured__wrap.rotate").slick({
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  dots: true,
  fade: true,
  adaptiveHeight: false,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        adaptiveHeight: true,
      },
    },
  ],
});
